export const HAVE_BANK_ACCOUNT = 'haveBankAccount';
export const CHOOSING_BANK = 'choosingBank';
export const HISTORY = 'history';
export const MONEY_ADDED = 'moneyAdded';
export const KYC_IN_PROGRESS = 'kycInProgress';
export const SUBMITTED = 'submitted';
